const { getElements } = window.BAO.Utils

class RecommendationsAPILayer {
  constructor () {
    this.fetchPlacements()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.SETTLED,
      this.handleCartSettled.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.handleOptionChanged.bind(this),
    )
  }

  fetchPlacements ({ update, productId, variantId, scope } = {}) {
    try {
      window.nostojs((api) => {
        let pageApi = api.defaultSession()

        if (update) {
          pageApi = api
            .defaultSession()
            .setResponseMode('HTML')
            .enableCampaignInjection()
        }

        switch (this.pageType) {
          case '404':
            pageApi = pageApi.viewNotFound()
            break
          case 'cart':
            pageApi = pageApi.viewCart()
            break
          case 'collection':
            pageApi = pageApi.viewCategory(this.categoryId)
            break
          case 'index':
            pageApi = pageApi.viewFrontPage()
            break
          case 'product':
            if (variantId) {
              pageApi = pageApi.viewProductSku(
                productId || this.productId,
                `${variantId}`,
              )
            } else {
              pageApi = pageApi.viewProduct(productId || this.productId)
            }
            break
          case 'search':
            pageApi = pageApi.viewSearch(this.searchQuery)
            break
          default:
            pageApi = pageApi.viewOther()
            break
        }

        pageApi
          .setPlacements(api.placements.getPlacements())
          .load()
          .then((response) => {
            let placements = []

            if (update) {
              placements = Object.keys(response?.recommendations)
            } else {
              Object.entries(response.campaigns?.recommendations).forEach(
                ([key, entry]) => {
                  if (!entry.products?.length) return
                  placements.push(key)
                },
              )
            }

            this.toggleElements(placements, scope)
            window.BAO.dispatchEvent(window.BAO.EVENTS.NOSTO.UPDATED)
          })
          .catch((error) => {
            console.error('Failed to fetch placements from Nosto:', error)
          })
      })
    } catch (error) {
      console.error('NostoJS API call failed:', error)
    }
  }

  toggleElements (placements, scope) {
    if (window.Shopify.designMode) return
    const recommendationEls = getElements('.nosto_element')

    recommendationEls.forEach((recommendationEl) => {
      // Ignore app block elements as they're handled by Nosto
      if (recommendationEl.closest('.shopify-app-block')) return

      const id = recommendationEl.id

      if (scope && !scope.includes(id)) return
      if (!scope && recommendationEl.closest('[data-product-oos]')) return

      if (placements.includes(id)) {
        recommendationEl.removeAttribute('hidden')
        return
      }

      recommendationEl.setAttribute('hidden', '')
    })
  }

  async handleCartSettled () {
    await window.Nosto.reloadCart()
    this.fetchPlacements({ update: true })
  }

  handleOptionChanged ({ detail }) {
    const variantId = detail?.variant?.id
    if (!variantId) return
    if (detail.variant.available !== false) return

    const oosPlacementId = document.querySelector(
      '[data-product-oos] .nosto_element',
    )?.id
    if (!oosPlacementId) return

    this.fetchPlacements({ update: true, variantId, scope: [oosPlacementId] })
  }

  get categoryId () {
    return document.body.dataset.categoryId
  }

  get pageType () {
    return document.body.dataset.pageType
  }

  get productId () {
    return document.body.dataset.productId
  }

  get searchQuery () {
    return document.body.dataset.searchQuery
  }
}

window.theme.recommendations.apiLayer = new RecommendationsAPILayer()
